import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerificationLicenseFront = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 240,
	height: 200,
	viewBox: "0 0 240 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".b{fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M230.3,18.76h-25.07c-.94,0-1.7,.76-1.7,1.7s.76,1.7,1.7,1.7h23.37v23.37c0,.94,.76,1.7,1.7,1.7s1.7-.76,1.7-1.7V20.46c0-.94-.76-1.7-1.7-1.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M86.29,22.79c1.72,0,3.11-1.4,3.11-3.11s-1.4-3.11-3.11-3.11-3.11,1.4-3.11,3.11,1.4,3.11,3.11,3.11Zm0-5.24c1.17,0,2.13,.96,2.13,2.13s-.96,2.13-2.13,2.13-2.13-.96-2.13-2.13,.96-2.13,2.13-2.13Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M174.55,24.03h4.15v4.15c0,.7,.56,1.26,1.26,1.26s1.26-.56,1.26-1.26v-4.15h4.15c.7,0,1.26-.56,1.26-1.26s-.56-1.26-1.26-1.26h-4.15v-4.15c0-.7-.56-1.26-1.26-1.26s-1.26,.56-1.26,1.26v4.15h-4.15c-.7,0-1.26,.56-1.26,1.26s.56,1.26,1.26,1.26Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M88,167.41h-5.54v-5.54c0-.93-.75-1.68-1.68-1.68s-1.68,.75-1.68,1.68v5.54h-5.54c-.93,0-1.68,.75-1.68,1.68s.75,1.68,1.68,1.68h5.54v5.54c0,.93,.75,1.68,1.68,1.68s1.68-.75,1.68-1.68v-5.54h5.54c.93,0,1.68-.75,1.68-1.68s-.75-1.68-1.68-1.68Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M10.4,178.54c-1.23,0-2.22,1-2.22,2.22s1,2.22,2.22,2.22,2.22-1,2.22-2.22-1-2.22-2.22-2.22Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M14.88,47.23c.94,0,1.7-.76,1.7-1.7V22.16h23.37c.94,0,1.7-.76,1.7-1.7s-.76-1.7-1.7-1.7H14.88c-.94,0-1.7,.76-1.7,1.7v25.07c0,.94,.76,1.7,1.7,1.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M39.95,169.25H16.58v-23.37c0-.94-.76-1.7-1.7-1.7s-1.7,.76-1.7,1.7v25.07c0,.94,.76,1.7,1.7,1.7h25.07c.94,0,1.7-.76,1.7-1.7s-.76-1.7-1.7-1.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M230.3,144.18c-.94,0-1.7,.76-1.7,1.7v23.37h-23.37c-.94,0-1.7,.76-1.7,1.7h0c0,.94,.76,1.7,1.7,1.7h25.07c.94,0,1.7-.76,1.7-1.7h0v-25.07c0-.94-.76-1.7-1.7-1.7Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 87.46,
			cy: 81.47,
			r: 16.46
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M216.88,142.53V50.66c0-6.81-6.31-12.33-14.1-12.33H45.07c-7.78,0-14.1,5.52-14.1,12.33v91.86c0,6.81,6.31,12.33,14.1,12.33H202.78c7.79,0,14.1-5.52,14.1-12.33Zm-95.62-3.61c-1.71,0-3.11-1.39-3.11-3.11,0-17.42-14.16-31.59-31.57-31.59s-31.57,14.17-31.57,31.59c0,1.72-1.39,3.11-3.11,3.11s-3.11-1.39-3.11-3.11c0-10.1,3.93-19.59,11.07-26.73,3.98-3.98,8.69-6.97,13.84-8.83-6.07-4.14-10.07-11.11-10.07-18.99,0-12.66,10.3-22.96,22.95-22.96s22.95,10.3,22.95,22.96c0,7.89-4,14.86-10.07,18.99,5.14,1.86,9.85,4.84,13.84,8.83,7.14,7.14,11.07,16.63,11.07,26.73,0,1.72-1.39,3.11-3.11,3.11Zm64.73-14.84h-42.12c-1.71,0-3.11-1.39-3.11-3.11s1.39-3.11,3.11-3.11h42.12c1.71,0,3.11,1.39,3.11,3.11s-1.39,3.11-3.11,3.11Zm9.97-19.85h-62.06c-1.71,0-3.11-1.39-3.11-3.11s1.39-3.11,3.11-3.11h62.06c1.71,0,3.11,1.39,3.11,3.11s-1.39,3.11-3.11,3.11Zm0-19.85h-62.06c-1.71,0-3.11-1.39-3.11-3.11s1.39-3.11,3.11-3.11h62.06c1.71,0,3.11,1.39,3.11,3.11s-1.39,3.11-3.11,3.11Z"
		})
	]
});
export default SvgVerificationLicenseFront;
